import { createSelector } from '@reduxjs/toolkit';
import { getEmployees } from './get-employees';
import { getCurrentUserEmail } from '../session';

import { isCurrentUser } from '../utilities/isCurrentUser';

export const currentEmployeeAsViewModel = createSelector(
  getEmployees,
  getCurrentUserEmail,
  (employees, currentUserEmail) => {
    const find = employees
      .filter(function (e) {
        return !e.deleted;
      })
      .filter(function (e) {
        return e.status !== 'TERMINATED';
      })
      .filter(function (e) {
        return isCurrentUser(e.email, currentUserEmail);
      });

    if (find.length === 1) {
      return find[0];
    }

    return undefined;
  },
);
